<template>
  <div
    class="country-card card-condition connection-type brand-and-models"
    :class="{ 'brand-and-models__notequals': predicate === 'NOT_EQUALS' }"
  >
    <div class="loading-overlay" v-if="loading">
      <loading-circle width="32" height="32" layout="inline" />
      {{ title }}...
    </div>
    <ui-icon size="12" class="card-condition__close" icon="fas fa-times" @click="emit('close')"></ui-icon>
    <div class="overflow-auto">
      <div class="panel-wrapper">
        <ui-radio-group
          style-type="inline"
          v-if="!loading"
          v-model="predicate"
          :label="title"
          :label-help="labelHelp"
        >
          <div class="d-flex align-baseline">
            <ui-radio
              class="ml-16"
              v-for="predicateOption in panelPredicates"
              :key="predicateOption.value"
              :value="predicateOption.value"
              :label="predicateOption.label"
            />
          </div>
        </ui-radio-group>

        <div v-if="!loading">
          <ui-checkbox
            class="pt-8"
            :label="t('Include unknown')"
            v-model="includeUnknown"
            :hide-details="1"
          />
        </div>
        <div v-if="!loading" class="d-flex">
          <three-panel-condition-category-list
            class="category-list"
            :prefix="prefix"
            :selected-brands="selectedBrands"
            :brand-select-all-index="brandSelectAllIndex"
            :data="data"
            :selected="selected"
            v-model:focused-item="focusedItem"
            @select-all="selectAll"
            @toggle="toggle"
          />
          <three-panel-condition-category-list
            class="category-list"
            :prefix="prefix"
            :first-panel="false"
            :selected-keys-index="selectedKeysIndex"
            :data="subItems"
            :selected="selected"
            v-model:focused-item="focusedItem"
            @toggle="toggle"
          />
          <div class="selected-list">
            <v-chip
              v-for="item in selectedAggregated"
              :key="item.name || item.brand"
              :data-index="item.name || item.brand"
              :color="$colors.green"
            >
              <span class="v-chip__label">{{ item.name || item.brand }}</span>
              <div class="v-chip__close" @click="remove(item.name || undefined, item.brand)">
                <i aria-hidden="true" class="v-icon fas fa-times-circle theme--light"></i>
              </div>
            </v-chip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingCircle from '@/components/loading-circle.vue';
import ThreePanelConditionCategoryList from './components/three-panel-condition-category-list.vue';
import { useFlowThreePanelCondition } from './useFlowThreePanelCondition';

const props = defineProps<{
  target?: unknown;
  conditions: Record<string, {
    values: string[];
    predicate: string;
    includeUnknown?: boolean;
  }>;
  prefix: string;
  loading: boolean;
  title: string;
  labelHelp?: string;
  name?: string;
  predicates?: Array<{ value: string; label: string }>;
  data: Array<{
    name: string;
    data: string[];
  }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const {
  t,
  $colors,
  focusedItem,
  selected,
  predicate,
  includeUnknown,
  brandSelectAllIndex,
  panelPredicates,
  selectedKeysIndex,
  selectedBrands,
  subItems,
  selectedAggregated,
  toggle,
  selectAll,
  remove,
} = useFlowThreePanelCondition(props);
</script>

<style lang="scss" scoped>
.panel-wrapper {
  min-width: 500px;
}

.selected-list {
  background: #fff;
  width: 33%;
  min-width: 0;
}

.category-list {
  :deep(.datatable-row__right-filler) {
    display: none;
  }
}
</style>
